import React from "react"

import BaseSvgIcon from "../Base"

const VerifiedUser = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 -960 960 960">
      <path d="m438-338 226-226-57-57-169 169-84-84-57 57zm42 258q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80m0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132m0-316" />
    </BaseSvgIcon>
  )
}

export default VerifiedUser
